/**
 * Cada slot define:
 *  - id:      identificador único
 *  - label:   texto visible en la cancha (abreviatura táctica)
 *  - role:    posición genérica ("Portero"|"Defensa"|"Medio"|"Delantero")
 *             — agrupa el slot en el panel lateral
 *  - roleKey: rol específico que debe estar en player.roles[]
 *             — filtra qué jugadores pueden ocupar este slot
 *  - x / y:   posición porcentual en la cancha (vertical: portero abajo)
 */

export const FORMATIONS = {
  "4-3-3": {
    label: "4-3-3",
    slots: [
      { id: "gk",  label: "POR", role: "Portero",   roleKey: "POR", x: 50, y: 90 },
      { id: "rb",  label: "LD",  role: "Defensa",   roleKey: "LD",  x: 79, y: 62 },
      { id: "rcb", label: "DFC", role: "Defensa",   roleKey: "DFC", x: 60, y: 72 },
      { id: "lcb", label: "DFC", role: "Defensa",   roleKey: "DFC", x: 40, y: 72 },
      { id: "lb",  label: "LI",  role: "Defensa",   roleKey: "LI",  x: 20, y: 62 },
      { id: "rm",  label: "MCD", role: "Medio",     roleKey: "MCD", x: 72, y: 43 },
      { id: "cm",  label: "MC",  role: "Medio",     roleKey: "MC",  x: 50, y: 35 },
      { id: "lm",  label: "MC",  role: "Medio",     roleKey: "MC",  x: 28, y: 43 },
      { id: "rw",  label: "ED",  role: "Delantero", roleKey: "ED",  x: 80, y: 20 },
      { id: "st",  label: "DC",  role: "Delantero", roleKey: "DC",  x: 50, y: 14 },
      { id: "lw",  label: "EI",  role: "Delantero", roleKey: "EI",  x: 20, y: 20 },
    ],
  },
  "4-4-2": {
    label: "4-4-2",
    slots: [
      { id: "gk",  label: "POR", role: "Portero",   roleKey: "POR", x: 50, y: 90 },
      { id: "rb",  label: "LD",  role: "Defensa",   roleKey: "LD",  x: 82, y: 72 },
      { id: "rcb", label: "DFC", role: "Defensa",   roleKey: "DFC", x: 62, y: 72 },
      { id: "lcb", label: "DFC", role: "Defensa",   roleKey: "DFC", x: 38, y: 72 },
      { id: "lb",  label: "LI",  role: "Defensa",   roleKey: "LI",  x: 18, y: 72 },
      { id: "rm",  label: "MD",  role: "Medio",     roleKey: "MD",  x: 80, y: 50 },
      { id: "rcm", label: "MC",  role: "Medio",     roleKey: "MC",  x: 60, y: 50 },
      { id: "lcm", label: "MC",  role: "Medio",     roleKey: "MC",  x: 40, y: 50 },
      { id: "lm",  label: "MC",  role: "Medio",     roleKey: "MC",  x: 20, y: 50 },
      { id: "rst", label: "DC",  role: "Delantero", roleKey: "DC",  x: 62, y: 18 },
      { id: "lst", label: "DC",  role: "Delantero", roleKey: "DC",  x: 38, y: 18 },
    ],
  },
  "4-2-3-1": {
    label: "4-2-3-1",
    slots: [
      { id: "gk",  label: "POR", role: "Portero",   roleKey: "POR", x: 50, y: 90 },
      { id: "rb",  label: "LD",  role: "Defensa",   roleKey: "LD",  x: 82, y: 72 },
      { id: "rcb", label: "DFC", role: "Defensa",   roleKey: "DFC", x: 62, y: 72 },
      { id: "lcb", label: "DFC", role: "Defensa",   roleKey: "DFC", x: 38, y: 72 },
      { id: "lb",  label: "LI",  role: "Defensa",   roleKey: "LI",  x: 18, y: 72 },
      { id: "rdm", label: "MCD", role: "Medio",     roleKey: "MCD", x: 60, y: 53 },
      { id: "ldm", label: "MCD", role: "Medio",     roleKey: "MCD", x: 40, y: 53 },
      { id: "ram", label: "MCO", role: "Medio",     roleKey: "MCO", x: 75, y: 38 },
      { id: "cam", label: "MCO", role: "Medio",     roleKey: "MCO", x: 50, y: 34 },
      { id: "lam", label: "MCO", role: "Medio",     roleKey: "MCO", x: 25, y: 38 },
      { id: "st",  label: "DC",  role: "Delantero", roleKey: "DC",  x: 50, y: 14 },
    ],
  },
  "3-4-3": {
    label: "3-4-3",
    slots: [
      { id: "gk",  label: "POR", role: "Portero",   roleKey: "POR", x: 50, y: 90 },
      { id: "rcb", label: "DFC", role: "Defensa",   roleKey: "DFC", x: 70, y: 69 },
      { id: "cb",  label: "DFC", role: "Defensa",   roleKey: "DFC", x: 50, y: 72 },
      { id: "lcb", label: "DFC", role: "Defensa",   roleKey: "DFC", x: 30, y: 69 },
      { id: "rm",  label: "MD",  role: "Medio",     roleKey: "MD",  x: 80, y: 52 },
      { id: "rcm", label: "MC",  role: "Medio",     roleKey: "MC",  x: 60, y: 40 },
      { id: "lcm", label: "MC",  role: "Medio",     roleKey: "MC",  x: 40, y: 40 },
      { id: "lm",  label: "MC",  role: "Medio",     roleKey: "MC",  x: 20, y: 52 },
      { id: "rw",  label: "ED",  role: "Delantero", roleKey: "ED",  x: 78, y: 18 },
      { id: "st",  label: "DC",  role: "Delantero", roleKey: "DC",  x: 50, y: 12 },
      { id: "lw",  label: "EI",  role: "Delantero", roleKey: "EI",  x: 22, y: 18 },
    ],
  },
  "5-3-2": {
    label: "5-3-2",
    slots: [
      { id: "gk",  label: "POR", role: "Portero",   roleKey: "POR", x: 50, y: 90 },
      { id: "rwb", label: "CAD", role: "Defensa",   roleKey: "CAD", x: 83, y: 55 },
      { id: "rcb", label: "DFC", role: "Defensa",   roleKey: "DFC", x: 68, y: 68 },
      { id: "cb",  label: "DFC", role: "Defensa",   roleKey: "DFC", x: 50, y: 74 },
      { id: "lcb", label: "DFC", role: "Defensa",   roleKey: "DFC", x: 32, y: 68 },
      { id: "lwb", label: "CAI", role: "Defensa",   roleKey: "CAI", x: 17, y: 55 },
      { id: "rm",  label: "MD",  role: "Medio",     roleKey: "MD",  x: 70, y: 36 },
      { id: "cm",  label: "MC",  role: "Medio",     roleKey: "MC",  x: 50, y: 43 },
      { id: "lm",  label: "MC",  role: "Medio",     roleKey: "MC",  x: 30, y: 36 },
      { id: "rst", label: "DC",  role: "Delantero", roleKey: "DC",  x: 62, y: 18 },
      { id: "lst", label: "DC",  role: "Delantero", roleKey: "DC",  x: 38, y: 18 },
    ],
  },
};

export const FORMATION_KEYS = Object.keys(FORMATIONS);
export const DEFAULT_FORMATION = "4-3-3";